<wbo-edit-grid [data]="model.data[fieldName]" [editable]="true" [entityPath]="fieldName" [removable]="true"
               [title]="'wbo.report.outlet-custom-object-selection.title'">
    <wbo-text-column [title]="'wbo.report.outlet-custom-object-selection.column.name'" field="name"></wbo-text-column>
    <wbo-text-column [title]="'wbo.report.outlet-custom-object-selection.column.customGroupType'"
                     field="customGroupType"></wbo-text-column>
    <wbo-edit-grid-add-row [customAdd]="true">
        <wbo-edit-grid-add-row-quick-add (onSelect)="addFromCustomObject([$event])">
            <wbo-custom-object-single-select-edit-control
                [outletContext]="true"></wbo-custom-object-single-select-edit-control>
        </wbo-edit-grid-add-row-quick-add>
        <wbo-edit-grid-add-row-actions>
            <wbo-edit-grid-add-row-search (onSelect)="addFromCustomObject($event)"
                                          [searchComponent]="OutletCustomObjectSearchPageComponent">
            </wbo-edit-grid-add-row-search>
        </wbo-edit-grid-add-row-actions>
    </wbo-edit-grid-add-row>
</wbo-edit-grid>
